import Repository from "../../services/Repository"
const reSource =  '/Configs';
const reSource2 =  '/Categories';

export default {
    get(data ){
        return Repository.get(  `${reSource}/` + data);
    },
    CreateAndUpdate(data ){
        return Repository.post(`${reSource}/` , data);
    },
    UpdateWordPressPosts( ){
        return Repository.get(`${reSource2}/wp-update-posts`,{timeout:300000} );
    },
    UpdateWordPressCategory( ){
        return Repository.get(`${reSource2}/wp-update-category` );
    },
}
